<template>
    <b-modal ref="createAudit" id="createAudit" size="lg" @hide="onHide" @show="onShow" top :title="postTitle">
        <b-row>
            <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="4">
                {{this.$t('auditType')}}
            </b-col>
            <b-col>
                <b-form-select style="height: 35px;" v-model="audit.type">
                    <option v-for="dataType in getAuditTypes()" :key="dataType.type" v-bind:value="dataType.type">{{dataType.displayName}}</option>
                </b-form-select>
            </b-col>
        </b-row>
        <b-row style="margin-top:10px">
            <b-col style="text-align: left;font-weight: bold; margin-top:10px" md="4">
                {{this.$t('auditDate')}}
            </b-col>
            <b-col>
                <el-date-picker
                    :placeholder="$t('chooseDatePlaceholder')"
                    v-model="audit.date"
                    type="date"
                    format="dd/MM/yyyy"
                    style="width: 100%"
                  />
            </b-col>
        </b-row>
        <b-row style="margin-top:10px">
            <b-col style="text-align: left;font-weight: bold; margin-top:7px" md="4">
                {{this.$t('branch')}}
            </b-col>
            <b-col>
                <multiselect
                    :disabled="this.$store.state.modal.payload.editType==='update'||this.$store.state.modal.payload.editType==='createDetail'"
                    :class="{'is-invalid': errors.sites}"
                    @focus.native="errors.branches = false"
                    v-model="audit.branches"
                    :multiple="true"
                    :options="$store.state.sites"
                    :close-on-select="true"
                    :showLabels="false"
                    :placeholder="$t('choose')"
                    label="name"
                    track-by="id"
                />
            </b-col>
        </b-row>
        <b-row style="margin-top:15px">
            <b-col style="text-align: left;font-weight: bold;" :md="this.gbId(this.$store.state.user.customerId) ? 4 : 2">
                {{this.$t(this.gbId(this.$store.state.user.customerId) ? 'otherEvaluations': 'title')}}
            </b-col>
            <b-col>
                <b-form-input
                    v-model="audit.title"
                    :placeholder="this.$t(this.gbId(this.$store.state.user.customerId) ? 'otherEvaluations': 'title')"
                    :value="audit?audit.title:null"
                    :class="{'is-invalid': errors.text}" @focus.native="errors.text = false"
                    style="height: 35px;margin-top: -5px;"
                  />
            </b-col>
        </b-row>
        <b-row class="my-1">
            <b-col style="text-align: left;font-weight: bold; margin-top:10px">
                <label>{{ $t('additionalFiles') }}</label>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-row align-h="start" no-gutters>
                    <b-col cols="1" align-h="start" no-gutters style="text-align: left">
                        <upload-regular 
                            fileCategory="audit-record"
                            @onupload="onupload"/>
                    </b-col>
                    <template v-if="audit.files">
                        <template v-for="(file, index) in audit.files">
                            <b-col cols="1" v-bind:key="`upload-${index}`">
                                <upload 
                                    fileCategory="audit-record"
                                    :showUpload="false" 
                                    :showDownload="false" 
                                    :reactive-id="`${reactiveId}-${file.uuid}-${index}`" 
                                    :deleteFromDB="true"
                                    :dataId="file.id"
                                    @onremove="onRemove(file)"/>
                                <div style="font-size: 12px; text-align: center">{{file.filename | textToShortText}}</div>
                            </b-col>
                        </template>
                    </template>
                </b-row>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button @click="type === 'update' ? update() : insert()" variant="Primary">{{ $t('save') }}</b-button>
            <b-button @click="closeModal(true)" variant="Danger">{{ $t('cancel') }}</b-button>
        </div>
    </b-modal>
</template>

<script>
import Upload from '../../components/Upload';
import UploadRegular from '../../components/UploadRegular';
import uuid from 'uuid/v4';
import Multiselect from 'vue-multiselect';
import _ from 'lodash';

export default {
    name: 'createAudit',
    components: {UploadRegular, Upload, Multiselect},
    data() {
        return {
            filesInWait: [],
            audit: {
                title: null,
                type: 'E',
                date: null,
                branches: [],
                files: []
            },
            reload: () => {},
            selectedSiteId: null,
            selectedYear: null,
            editType: null,
            filteredSites: [],
            reactiveId: uuid(),
            siteId: null,
            type: null,
            postId: null,
            postDocuments: [],
            onCloud: false,
            errors: {
                title: false,
                type: false,
                date: false,
                branches: false,
                files: false
            }
        };
    },
    methods: {
        onupload(event) {
              let fileToAdd = {
                id: event.id,
                filename: event.filename,
                uuid: event.fileId,
                fileUrl: event.fileUrl
            };
            _.isEmpty(_.get(this.audit, 'files')) ?
                this.audit.files = [fileToAdd] :
                this.audit.files.push(fileToAdd);
            this.onCloud = event.onCloud;
            this.filesInWait.push(event.id);
        },
        getAuditTypes() {
            let auditTypes = [
                {type: 'E', displayName: this.$t('externalAudit')},
                {type: 'I', displayName: this.$t('internalAudit')},
                {type: 'C', displayName: this.$t('control')}
            ];
            return auditTypes;
        },
        onHide(event){
            if(_.get(event, 'trigger') != null){
                this.closeModal(true);
            }
        },
        closeModal(deleteFiles=false) {
            if(!_.isEmpty(this.filesInWait) && deleteFiles && this.onCloud){
                this.axios.post('/deleteFilesFromAWS',{files:this.filesInWait})
                    .then(()=>{
                        this.filesInWait = [];
                        this.$refs.createAudit.hide();
                    })
            }else{
                this.filesInWait = [];
                this.$refs.createAudit.hide();
            }
        },
        insert() {
            if (this.isValidInsertion()) {
                let auditDate = new Date(this.audit.date);
                auditDate = new Date(
                    Date.UTC(auditDate.getFullYear(), auditDate.getMonth(), auditDate.getDate())
                );
                return this.axios
                    .post(
                        `/audits/create`,
                        this.configureAuditBeforeSending({...this.audit, date: auditDate})
                    )
                    .then(() => {
                        this.closeModal();
                    })
                    .then(() => {
                        if (this.editType === 'createDetail') {
                            this.reload(this.selectedYear, this.siteId, this.selectedType);
                        } else {
                            this.reload(this.selectedRegionId, this.selectedTypeId);
                        }
                    });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        isValidInsertion() {
            this.errors.title = !this.audit.title;
            this.errors.type = !this.audit.type;
            this.errors.date = !this.audit.date;
            this.errors.branches = !this.audit.branches.length == 0 ? false : true;
            // this.errors.file = !(this.audit.file);
            let validation = true;
            for (let key in this.errors) {
                validation &= !this.errors[key];
            }
            return validation;
        },
        update() {
            if (this.isValidInsertion()) {
                return this.axios
                    .post(`/audit/update`, this.configureAuditBeforeSending(this.audit))
                    .then(() => {
                        this.closeModal();
                    })
                    .then(() => {
                        this.reload(this.selectedYear, this.siteId, this.selectedType);
                    });
            } else {
                this.$toasted.error(this.$t('missingError'));
            }
        },
        onRemove(file) {
            if(_.includes(Object.keys(file), 'id')){
                this.filesInWait = _.remove(this.filesInWait, file.id);
            }
            this.audit.files =_.remove(this.audit.files, function(nFile){
                return _.get(file, 'uuid') != _.get(nFile, 'uuid');
            });
            if(_.isEmpty(this.audit.files)){this.audit.files=[];}
        },
        configureAuditBeforeSending(audit) {
            let configuredAudit = {};
            Object.assign(configuredAudit, audit);
            if (configuredAudit.branches && configuredAudit.branches.length > 0) {
                configuredAudit.branches = _.reduce(
                    configuredAudit.branches,
                    (newBranches, branch) => {
                        newBranches.push(branch.id);
                        return newBranches;
                    },
                    []
                );
            }
            return configuredAudit;
        },
        onShow() {
            Object.assign(this.$data, this.$options.data());
            this.filesInWait = [];
            let payload = this.$store.state.modal.payload;
            this.editType = payload.editType;
            this.reload = payload.reloadFunction;
            this.selectedRegionId = payload.selectedRegionId;
            this.selectedType = payload.selectedType; // this is for audit type
            this.selectedYear = payload.selectedYear;
            this.selectedTypeId = payload.selectedTypeId; // This is for get sites (site types)
            if (payload && (payload.editType === 'update' || payload.editType === 'createDetail')) {
                let post = payload.post;
                this.type = payload.editType;
                this.siteId = payload.siteId;
                if (post) {
                    this.audit.title = post.title;
                    this.audit.type = post.type;
                    this.audit.date = post.audit_date;
                    this.audit.record_id = post.record_id;
                    this.audit.document_id = post.document_id;
                    this.audit.audit_record_document_id = post.audit_record_document_id;
                    if (post.files) {
                        this.audit.files = post.files;
                    }
                }
                let foundSite = _.find(this.$store.state.sites, {id: Number(payload.siteId)});
                if (foundSite) {
                    this.audit.branches.push(foundSite);
                }
            }
        }
    },
    computed: {
        postTitle() {
            return this.type === 'updatePost' ? this.$t('updateAudit') : this.$t('createAudit');
        }
    }
};
</script>

<style scoped>
</style>

<i18n src="../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "createAudit": "Yeni Denetim Tarihi Ekle",
            "updateAudit": "Denetim Tarihi Güncelle",
            "title": "Başlık",
            "additionalFiles": "Ek Dosyalar",
            "auditType": "Denetim Tipi",
            "auditDate": "Denetim Tarihi",
            "branch": "Denetim Yapılacak Lokasyon"
        },
        "en": {
            "createAudit": "Add New Audit Date",
            "updateAudit": "Update Audit Date",
            "title": "Title",
            "additionalFiles": "Additional Files",
            "auditType": "Audit Type",
            "auditDate": "Audit Date",
            "branch": "Locations for Audit"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/components/modals/CreateAudit.vue